import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e43de68c = () => interopDefault(import('../../../pages/awnings/index.vue' /* webpackChunkName: "pages/awnings/index" */))
const _484703e2 = () => interopDefault(import('../../../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _24bf2e08 = () => interopDefault(import('../../../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _f334fd00 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6b45da26 = () => interopDefault(import('../../../pages/domestic-water/index.vue' /* webpackChunkName: "pages/domestic-water/index" */))
const _65a26414 = () => interopDefault(import('../../../pages/doors/index.vue' /* webpackChunkName: "pages/doors/index" */))
const _4656ba0f = () => interopDefault(import('../../../pages/energy-metering/index.vue' /* webpackChunkName: "pages/energy-metering/index" */))
const _57f92872 = () => interopDefault(import('../../../pages/gateway.vue' /* webpackChunkName: "pages/gateway" */))
const _c58864ba = () => interopDefault(import('../../../pages/heating/index.vue' /* webpackChunkName: "pages/heating/index" */))
const _005ee7d9 = () => interopDefault(import('../../../pages/household-appliances/index.vue' /* webpackChunkName: "pages/household-appliances/index" */))
const _7992a4d3 = () => interopDefault(import('../../../pages/irrigation/index.vue' /* webpackChunkName: "pages/irrigation/index" */))
const _2052b8e7 = () => interopDefault(import('../../../pages/it-audio-video/index.vue' /* webpackChunkName: "pages/it-audio-video/index" */))
const _74c7f65e = () => interopDefault(import('../../../pages/lighting/index.vue' /* webpackChunkName: "pages/lighting/index" */))
const _1f80ab82 = () => interopDefault(import('../../../pages/safety-and-security/index.vue' /* webpackChunkName: "pages/safety-and-security/index" */))
const _533458aa = () => interopDefault(import('../../../pages/shades/index.vue' /* webpackChunkName: "pages/shades/index" */))
const _6c007260 = () => interopDefault(import('../../../pages/spa-and-pool/index.vue' /* webpackChunkName: "pages/spa-and-pool/index" */))
const _75cc0364 = () => interopDefault(import('../../../pages/ventilation/index.vue' /* webpackChunkName: "pages/ventilation/index" */))
const _26c86af4 = () => interopDefault(import('../../../pages/windows/index.vue' /* webpackChunkName: "pages/windows/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/forms/order/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/awnings",
    component: _e43de68c,
    name: "awnings___en"
  }, {
    path: "/cart",
    component: _484703e2,
    name: "cart___en"
  }, {
    path: "/checkout",
    component: _24bf2e08,
    name: "checkout___en"
  }, {
    path: "/de",
    component: _f334fd00,
    name: "index___de"
  }, {
    path: "/domestic-water",
    component: _6b45da26,
    name: "domestic-water___en"
  }, {
    path: "/doors",
    component: _65a26414,
    name: "doors___en"
  }, {
    path: "/energy-metering",
    component: _4656ba0f,
    name: "energy-metering___en"
  }, {
    path: "/es",
    component: _f334fd00,
    name: "index___es"
  }, {
    path: "/fr",
    component: _f334fd00,
    name: "index___fr"
  }, {
    path: "/gateway",
    component: _57f92872,
    name: "gateway___en"
  }, {
    path: "/heating",
    component: _c58864ba,
    name: "heating___en"
  }, {
    path: "/household-appliances",
    component: _005ee7d9,
    name: "household-appliances___en"
  }, {
    path: "/irrigation",
    component: _7992a4d3,
    name: "irrigation___en"
  }, {
    path: "/it",
    component: _f334fd00,
    name: "index___it"
  }, {
    path: "/it-audio-video",
    component: _2052b8e7,
    name: "it-audio-video___en"
  }, {
    path: "/lighting",
    component: _74c7f65e,
    name: "lighting___en"
  }, {
    path: "/nl",
    component: _f334fd00,
    name: "index___nl"
  }, {
    path: "/safety-and-security",
    component: _1f80ab82,
    name: "safety-and-security___en"
  }, {
    path: "/shades",
    component: _533458aa,
    name: "shades___en"
  }, {
    path: "/sl",
    component: _f334fd00,
    name: "index___sl"
  }, {
    path: "/spa-and-pool",
    component: _6c007260,
    name: "spa-and-pool___en"
  }, {
    path: "/ventilation",
    component: _75cc0364,
    name: "ventilation___en"
  }, {
    path: "/windows",
    component: _26c86af4,
    name: "windows___en"
  }, {
    path: "/de/awnings",
    component: _e43de68c,
    name: "awnings___de"
  }, {
    path: "/de/cart",
    component: _484703e2,
    name: "cart___de"
  }, {
    path: "/de/checkout",
    component: _24bf2e08,
    name: "checkout___de"
  }, {
    path: "/de/domestic-water",
    component: _6b45da26,
    name: "domestic-water___de"
  }, {
    path: "/de/doors",
    component: _65a26414,
    name: "doors___de"
  }, {
    path: "/de/energy-metering",
    component: _4656ba0f,
    name: "energy-metering___de"
  }, {
    path: "/de/gateway",
    component: _57f92872,
    name: "gateway___de"
  }, {
    path: "/de/heating",
    component: _c58864ba,
    name: "heating___de"
  }, {
    path: "/de/household-appliances",
    component: _005ee7d9,
    name: "household-appliances___de"
  }, {
    path: "/de/irrigation",
    component: _7992a4d3,
    name: "irrigation___de"
  }, {
    path: "/de/it-audio-video",
    component: _2052b8e7,
    name: "it-audio-video___de"
  }, {
    path: "/de/lighting",
    component: _74c7f65e,
    name: "lighting___de"
  }, {
    path: "/de/safety-and-security",
    component: _1f80ab82,
    name: "safety-and-security___de"
  }, {
    path: "/de/shades",
    component: _533458aa,
    name: "shades___de"
  }, {
    path: "/de/spa-and-pool",
    component: _6c007260,
    name: "spa-and-pool___de"
  }, {
    path: "/de/ventilation",
    component: _75cc0364,
    name: "ventilation___de"
  }, {
    path: "/de/windows",
    component: _26c86af4,
    name: "windows___de"
  }, {
    path: "/es/awnings",
    component: _e43de68c,
    name: "awnings___es"
  }, {
    path: "/es/cart",
    component: _484703e2,
    name: "cart___es"
  }, {
    path: "/es/checkout",
    component: _24bf2e08,
    name: "checkout___es"
  }, {
    path: "/es/domestic-water",
    component: _6b45da26,
    name: "domestic-water___es"
  }, {
    path: "/es/doors",
    component: _65a26414,
    name: "doors___es"
  }, {
    path: "/es/energy-metering",
    component: _4656ba0f,
    name: "energy-metering___es"
  }, {
    path: "/es/gateway",
    component: _57f92872,
    name: "gateway___es"
  }, {
    path: "/es/heating",
    component: _c58864ba,
    name: "heating___es"
  }, {
    path: "/es/household-appliances",
    component: _005ee7d9,
    name: "household-appliances___es"
  }, {
    path: "/es/irrigation",
    component: _7992a4d3,
    name: "irrigation___es"
  }, {
    path: "/es/it-audio-video",
    component: _2052b8e7,
    name: "it-audio-video___es"
  }, {
    path: "/es/lighting",
    component: _74c7f65e,
    name: "lighting___es"
  }, {
    path: "/es/safety-and-security",
    component: _1f80ab82,
    name: "safety-and-security___es"
  }, {
    path: "/es/shades",
    component: _533458aa,
    name: "shades___es"
  }, {
    path: "/es/spa-and-pool",
    component: _6c007260,
    name: "spa-and-pool___es"
  }, {
    path: "/es/ventilation",
    component: _75cc0364,
    name: "ventilation___es"
  }, {
    path: "/es/windows",
    component: _26c86af4,
    name: "windows___es"
  }, {
    path: "/fr/awnings",
    component: _e43de68c,
    name: "awnings___fr"
  }, {
    path: "/fr/cart",
    component: _484703e2,
    name: "cart___fr"
  }, {
    path: "/fr/checkout",
    component: _24bf2e08,
    name: "checkout___fr"
  }, {
    path: "/fr/domestic-water",
    component: _6b45da26,
    name: "domestic-water___fr"
  }, {
    path: "/fr/doors",
    component: _65a26414,
    name: "doors___fr"
  }, {
    path: "/fr/energy-metering",
    component: _4656ba0f,
    name: "energy-metering___fr"
  }, {
    path: "/fr/gateway",
    component: _57f92872,
    name: "gateway___fr"
  }, {
    path: "/fr/heating",
    component: _c58864ba,
    name: "heating___fr"
  }, {
    path: "/fr/household-appliances",
    component: _005ee7d9,
    name: "household-appliances___fr"
  }, {
    path: "/fr/irrigation",
    component: _7992a4d3,
    name: "irrigation___fr"
  }, {
    path: "/fr/it-audio-video",
    component: _2052b8e7,
    name: "it-audio-video___fr"
  }, {
    path: "/fr/lighting",
    component: _74c7f65e,
    name: "lighting___fr"
  }, {
    path: "/fr/safety-and-security",
    component: _1f80ab82,
    name: "safety-and-security___fr"
  }, {
    path: "/fr/shades",
    component: _533458aa,
    name: "shades___fr"
  }, {
    path: "/fr/spa-and-pool",
    component: _6c007260,
    name: "spa-and-pool___fr"
  }, {
    path: "/fr/ventilation",
    component: _75cc0364,
    name: "ventilation___fr"
  }, {
    path: "/fr/windows",
    component: _26c86af4,
    name: "windows___fr"
  }, {
    path: "/it/awnings",
    component: _e43de68c,
    name: "awnings___it"
  }, {
    path: "/it/cart",
    component: _484703e2,
    name: "cart___it"
  }, {
    path: "/it/checkout",
    component: _24bf2e08,
    name: "checkout___it"
  }, {
    path: "/it/domestic-water",
    component: _6b45da26,
    name: "domestic-water___it"
  }, {
    path: "/it/doors",
    component: _65a26414,
    name: "doors___it"
  }, {
    path: "/it/energy-metering",
    component: _4656ba0f,
    name: "energy-metering___it"
  }, {
    path: "/it/gateway",
    component: _57f92872,
    name: "gateway___it"
  }, {
    path: "/it/heating",
    component: _c58864ba,
    name: "heating___it"
  }, {
    path: "/it/household-appliances",
    component: _005ee7d9,
    name: "household-appliances___it"
  }, {
    path: "/it/irrigation",
    component: _7992a4d3,
    name: "irrigation___it"
  }, {
    path: "/it/it-audio-video",
    component: _2052b8e7,
    name: "it-audio-video___it"
  }, {
    path: "/it/lighting",
    component: _74c7f65e,
    name: "lighting___it"
  }, {
    path: "/it/safety-and-security",
    component: _1f80ab82,
    name: "safety-and-security___it"
  }, {
    path: "/it/shades",
    component: _533458aa,
    name: "shades___it"
  }, {
    path: "/it/spa-and-pool",
    component: _6c007260,
    name: "spa-and-pool___it"
  }, {
    path: "/it/ventilation",
    component: _75cc0364,
    name: "ventilation___it"
  }, {
    path: "/it/windows",
    component: _26c86af4,
    name: "windows___it"
  }, {
    path: "/nl/awnings",
    component: _e43de68c,
    name: "awnings___nl"
  }, {
    path: "/nl/cart",
    component: _484703e2,
    name: "cart___nl"
  }, {
    path: "/nl/checkout",
    component: _24bf2e08,
    name: "checkout___nl"
  }, {
    path: "/nl/domestic-water",
    component: _6b45da26,
    name: "domestic-water___nl"
  }, {
    path: "/nl/doors",
    component: _65a26414,
    name: "doors___nl"
  }, {
    path: "/nl/energy-metering",
    component: _4656ba0f,
    name: "energy-metering___nl"
  }, {
    path: "/nl/gateway",
    component: _57f92872,
    name: "gateway___nl"
  }, {
    path: "/nl/heating",
    component: _c58864ba,
    name: "heating___nl"
  }, {
    path: "/nl/household-appliances",
    component: _005ee7d9,
    name: "household-appliances___nl"
  }, {
    path: "/nl/irrigation",
    component: _7992a4d3,
    name: "irrigation___nl"
  }, {
    path: "/nl/it-audio-video",
    component: _2052b8e7,
    name: "it-audio-video___nl"
  }, {
    path: "/nl/lighting",
    component: _74c7f65e,
    name: "lighting___nl"
  }, {
    path: "/nl/safety-and-security",
    component: _1f80ab82,
    name: "safety-and-security___nl"
  }, {
    path: "/nl/shades",
    component: _533458aa,
    name: "shades___nl"
  }, {
    path: "/nl/spa-and-pool",
    component: _6c007260,
    name: "spa-and-pool___nl"
  }, {
    path: "/nl/ventilation",
    component: _75cc0364,
    name: "ventilation___nl"
  }, {
    path: "/nl/windows",
    component: _26c86af4,
    name: "windows___nl"
  }, {
    path: "/sl/awnings",
    component: _e43de68c,
    name: "awnings___sl"
  }, {
    path: "/sl/cart",
    component: _484703e2,
    name: "cart___sl"
  }, {
    path: "/sl/checkout",
    component: _24bf2e08,
    name: "checkout___sl"
  }, {
    path: "/sl/domestic-water",
    component: _6b45da26,
    name: "domestic-water___sl"
  }, {
    path: "/sl/doors",
    component: _65a26414,
    name: "doors___sl"
  }, {
    path: "/sl/energy-metering",
    component: _4656ba0f,
    name: "energy-metering___sl"
  }, {
    path: "/sl/gateway",
    component: _57f92872,
    name: "gateway___sl"
  }, {
    path: "/sl/heating",
    component: _c58864ba,
    name: "heating___sl"
  }, {
    path: "/sl/household-appliances",
    component: _005ee7d9,
    name: "household-appliances___sl"
  }, {
    path: "/sl/irrigation",
    component: _7992a4d3,
    name: "irrigation___sl"
  }, {
    path: "/sl/it-audio-video",
    component: _2052b8e7,
    name: "it-audio-video___sl"
  }, {
    path: "/sl/lighting",
    component: _74c7f65e,
    name: "lighting___sl"
  }, {
    path: "/sl/safety-and-security",
    component: _1f80ab82,
    name: "safety-and-security___sl"
  }, {
    path: "/sl/shades",
    component: _533458aa,
    name: "shades___sl"
  }, {
    path: "/sl/spa-and-pool",
    component: _6c007260,
    name: "spa-and-pool___sl"
  }, {
    path: "/sl/ventilation",
    component: _75cc0364,
    name: "ventilation___sl"
  }, {
    path: "/sl/windows",
    component: _26c86af4,
    name: "windows___sl"
  }, {
    path: "/",
    component: _f334fd00,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
